<template>
  <!--begin::Container-->
  <div id="kt_content_container">
    <div v-if="$store.state.uploadsPath == 'vidisci.websiran.com'" class="container-xxl my-5 row">
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countUsers }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">New users</h3>
          </div>
        </div>
      </div>
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countVideos }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">New videos</h3>
          </div>
        </div>
      </div>
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countRenderedVideos }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">Rendered videos</h3>
          </div>
        </div>
      </div>
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countViews }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">Total views</h3>
          </div>
        </div>
      </div>
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countComments }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">Submitted comments</h3>
          </div>
        </div>
      </div>
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countInteractions }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">Total interactions</h3>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="container-xxl my-5 row">
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countUsers }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">New users</h3>
          </div>
        </div>
      </div>
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countVideos }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">New manuscripts</h3>
          </div>
        </div>
      </div>
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countRenderedVideos }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">Accepted manuscripts</h3>
          </div>
        </div>
      </div>
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countViews }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">Total views</h3>
          </div>
        </div>
      </div>
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countComments }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">Submitted comments</h3>
          </div>
        </div>
      </div>
      <div class="p-5 col-12 col-md-6 col-lg-4">
        <div class="card">
          <div class="card-body d-flex flex-column justify-content-center align-items-center">
            <h2 class="fs-3">{{ countInteractions }}</h2>
            <i class="fs-1 bi bi-person"></i>
            <h3 class="fw-boldest fs-1">Total interactions</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end::Container-->
</template>

<script>
import dataService from "../../../services/data";
import serverConfigs from "../../../configs/server.json";

export default {
  components: {},
  computed: {
    backendHost() {
      return serverConfigs["serverDomain"]["host"];
    },
    routeLocale() {
      return this.$route.params.locale;
    }
  },
  setup() {},
  data() {
    return {
      countUsers: 0,
      countVideos: 0,
      countComments: 0,
      countViews: 0,
      countRenderedVideos: 0,
      countInteractions: 0
    }
  },
  methods: {
    readUsers(page) {
      let data = {
        endPoint: `users`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          this.countUsers = res.data.data.length;
        })
        .catch((error) => {
          this.$store.commit("setLoader", false);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        // .finally(() => {
        //   this.loaderStatus[1] = true;
        //   this.loaderDone();
        // });
    },
    readVideos(page) {
      let data = {
        endPoint: `blogs`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          this.countVideos = res.data.data.length;
          for (let d in res.data.data) {
            console.log(res.data.data[d])
            if ((typeof res.data.data[d]['blogBody'] == "string" && JSON.parse(res.data.data[d]['blogBody'])[0]['renderStatus']) || res.data.data[d]['blogPublish']) {
              this.countRenderedVideos += 1
            }
          }
        })
        .catch((error) => {
          console.log(error)
          this.$store.commit("setLoader", false);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        // .finally(() => {
        //   this.loaderStatus[1] = true;
        //   this.loaderDone();
        // });
    },
    readComments(page) {
      let data = {
        endPoint: `comments`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          this.countComments = res.data.data.length;
        })
        .catch((error) => {
          this.$store.commit("setLoader", false);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        // .finally(() => {
        //   this.loaderStatus[1] = true;
        //   this.loaderDone();
        // });
    },
    readViews(page) {
      let data = {
        endPoint: `metrics`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          this.countViews = res.data.data.length;
        })
        .catch((error) => {
          this.$store.commit("setLoader", false);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        // .finally(() => {
        //   this.loaderStatus[1] = true;
        //   this.loaderDone();
        // });
    },
    readInteractions(page) {
      let data = {
        endPoint: `interactions`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          this.countInteractions = res.data.data.length;
        })
        .catch((error) => {
          this.$store.commit("setLoader", false);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        // .finally(() => {
        //   this.loaderStatus[1] = true;
        //   this.loaderDone();
        // });
    },
  },
  mounted() {
    this.readUsers(0)
    this.readVideos(0)
    this.readComments(0)
    this.readViews(0)
    this.readInteractions(0)
  },
};
</script>

<style scoped></style>
